
<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      persistent
      width="85%"
      max-width="600"
    >
      <v-card>
        <v-card-title
          class="headline"
          primary-title
        >
          Distribution Center Locations
        </v-card-title>

        <v-card-text class="grey lighten-3">
          <v-container class="app" grid-list-md text-xs-center fluid>
            <v-layout row wrap>
              <v-flex xs12 v-for="(m, idx) in inprocessMarkets" :key="`m-${idx}`">
                <market-selector-card
                  :index="idx"
                  :markets="availableMarkets"
                  :market="m"
                  :showCustomMarkets="false"
                  v-on:market-did-change="marketDidChange"
                >                  
                </market-selector-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="didCancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="didApply()"
          >
            Apply
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'manage-locations',
  data () {
    return {
      inprocessMarkets: null
    }
  },

  props: {
    show: Boolean,
    markets: Array,
    availableMarkets: Array
  },

  methods: {
    didCancel() {
      this.$emit('did-cancel')      
    },
    didApply() {
      this.$emit('did-apply', this.inprocessMarkets)      
    },

    marketDidChange(ev) {
      let m = this.availableMarkets.find(o => o.name === ev.name)
      this.inprocessMarkets[ev.index] = m
      if(this.show) {
        this.$store.commit('setNaMarketManuallySpecified', true)
      }
    }
  },

  watch: {
    show(v) {
      if(v){
        this.inprocessMarkets = _.cloneDeep(this.markets)
      }
    }
  },

  computed: {
  },

  components: {
    'market-selector-card': () => import ('@/components/MarketSelectorCard')
  }
}

</script>


<style scoped>

</style>